import axios from 'axios'

const chatbotAxios = axios.create({
  baseURL: process.env.VUE_APP_CHATBOT_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
    'x-admin-secret': process.env.VUE_APP_CHATBOT_SECRET || '',
  },
})

export default chatbotAxios
